export var CardType;
(function (CardType) {
    CardType["VISA"] = "visa";
    CardType["MASTERCARD"] = "mastercard";
    CardType["AMEX"] = "amex";
    CardType["AMERICAN_EXPRESS"] = "americanexpress";
    CardType["DISCOVER"] = "discover";
    CardType["JCB"] = "jcb";
    CardType["UNKNOWN"] = "unknown";
})(CardType || (CardType = {}));
export var BillingInfoText;
(function (BillingInfoText) {
    BillingInfoText["DayBankDaysText"] = "Day Bank Days";
    BillingInfoText["CREDIT_DEBIT"] = "Credit/Debit";
    BillingInfoText["GIFT_CARDS"] = "Gift Cards";
    BillingInfoText["SEE_OLD_GIFT_CARDS"] = "See Old Gift Cards";
    BillingInfoText["GIFT_CARD_STARTING_BALANCE"] = "Starting Balance";
    BillingInfoText["GIFT_CARD_NUMBER"] = "Number";
    BillingInfoText["GIFT_CARD_BALANCE"] = "Balance";
    BillingInfoText["GIFT_CARD_SENDER"] = "Sender";
    BillingInfoText["GIFT_CARD_CREATED"] = "Created";
    BillingInfoText["NO_PAYMENT_METHODS_AVAILABLE"] = "You have no active payment methods.";
    BillingInfoText["NO_GIFT_CARDS_AVAILABLE"] = "You have no active gift cards.";
    BillingInfoText["GIFT_CARDS_MODAL_TITLE"] = "Gift Card Information";
    BillingInfoText["OLD_GIFT_CARDS_MODAL_TITLE"] = "Old Gift Cards";
    BillingInfoText["CC_TABLE_HEADER_CARD"] = "Card";
    BillingInfoText["CC_TABLE_HEADER_LAST4"] = "Last 4 Digits";
    BillingInfoText["CC_TABLE_HEADER_EXP"] = "Expiration";
    BillingInfoText["CC_TABLE_HEADER_PRIMARY"] = "Primary";
    BillingInfoText["CC_TABLE_HEADER_ACTIONS"] = "Actions";
})(BillingInfoText || (BillingInfoText = {}));
export const CARD_TYPES = {
    [CardType.VISA]: "/Assets/images/cc-visa.png",
    [CardType.MASTERCARD]: "/Assets/images/cc-mastercard.png",
    [CardType.AMEX]: "/Assets/images/cc-amex.png",
    [CardType.AMERICAN_EXPRESS]: "/Assets/images/cc-amex.png",
    [CardType.DISCOVER]: "/Assets/images/cc-discover.png",
    [CardType.JCB]: "/Assets/images/cc-jcb.png",
    [CardType.UNKNOWN]: "/Assets/images/cc-default.png",
};
/**
 * Returns the image for the card brand or a default image if one cannot be found
 *
 * @param brand
 * @returns
 */
export function getCardImage(brand) {
    return (!!brand && CARD_TYPES[brand.toLowerCase()]) || "/Assets/images/cc-default.png";
}
